module.exports = __webpack_public_path__ + "img/ic_exchange_actived.b8b49113.svg";